(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './androidx-compose-runtime-runtime.js', './kotlin-kotlin-stdlib.js', './coil-root-coil.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./androidx-compose-runtime-runtime.js'), require('./kotlin-kotlin-stdlib.js'), require('./coil-root-coil.js'));
  else {
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'coil-root-coil-compose'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'coil-root-coil-compose'.");
    }
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'coil-root-coil-compose'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'coil-root-coil-compose'.");
    }
    if (typeof globalThis['coil-root-coil'] === 'undefined') {
      throw new Error("Error loading module 'coil-root-coil-compose'. Its dependency 'coil-root-coil' was not found. Please, check whether 'coil-root-coil' is loaded prior to 'coil-root-coil-compose'.");
    }
    globalThis['coil-root-coil-compose'] = factory(typeof globalThis['coil-root-coil-compose'] === 'undefined' ? {} : globalThis['coil-root-coil-compose'], globalThis['androidx-compose-runtime-runtime'], globalThis['kotlin-kotlin-stdlib'], globalThis['coil-root-coil']);
  }
}(function (_, kotlin_androidx_compose_runtime_runtime, kotlin_kotlin, kotlin_io_coil_kt_coil3_coil) {
  'use strict';
  //region block: imports
  var sourceInformation = kotlin_androidx_compose_runtime_runtime.$_$.k2;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var traceEventStart = kotlin_androidx_compose_runtime_runtime.$_$.p2;
  var isTraceInProgress = kotlin_androidx_compose_runtime_runtime.$_$.s1;
  var SingletonImageLoader_getInstance = kotlin_io_coil_kt_coil3_coil.$_$.b;
  var traceEventEnd = kotlin_androidx_compose_runtime_runtime.$_$.o2;
  var protoOf = kotlin_kotlin.$_$.eh;
  var equals = kotlin_kotlin.$_$.sf;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var isInterface = kotlin_kotlin.$_$.rg;
  var Factory = kotlin_io_coil_kt_coil3_coil.$_$.a;
  var hashCode = kotlin_kotlin.$_$.bg;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var VOID = kotlin_kotlin.$_$.d;
  var updateChangedFlags = kotlin_androidx_compose_runtime_runtime.$_$.q2;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(sam$coil3_SingletonImageLoader_Factory$0, 'sam$coil3_SingletonImageLoader_Factory$0', VOID, VOID, [Factory, FunctionAdapter]);
  //endregion
  function setSingletonImageLoaderFactory(factory, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(505499498);
    sourceInformation($composer_0, 'C(setSingletonImageLoaderFactory):singletonImageLoaders.kt#8xxpns');
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(factory) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 3) === 2), $dirty & 1)) {
      if (isTraceInProgress()) {
        traceEventStart(505499498, $dirty, -1, 'coil3.compose.setSingletonImageLoaderFactory (singletonImageLoaders.kt:13)');
      }
      SingletonImageLoader_getInstance().vxk(new sam$coil3_SingletonImageLoader_Factory$0(factory));
      if (isTraceInProgress()) {
        traceEventEnd();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(setSingletonImageLoaderFactory$lambda(factory, $changed));
    }
  }
  function sam$coil3_SingletonImageLoader_Factory$0(function_0) {
    this.xxk_1 = function_0;
  }
  protoOf(sam$coil3_SingletonImageLoader_Factory$0).q3 = function () {
    return this.xxk_1;
  };
  protoOf(sam$coil3_SingletonImageLoader_Factory$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Factory) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$coil3_SingletonImageLoader_Factory$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function setSingletonImageLoaderFactory$lambda($factory, $$changed) {
    return function ($composer, $force) {
      setSingletonImageLoaderFactory($factory, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = setSingletonImageLoaderFactory;
  //endregion
  return _;
}));

//# sourceMappingURL=coil-root-coil-compose.js.map
